import { connect } from 'react-redux'
import ShopPickerPopup from './ShopPickerPopup'
import { nullSafe } from 'Utility/globalMethods'
import { doSetShopSelection, doClearShopSelection, clearSearchTerm, doSetShopSelectionMode, doClearShopLocalSelection, doGetShopList, doSetLocalSelectedTab } from 'Store/actions/shopPicker'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  setShopSelection: (group, data, selectorGroups) => dispatch(doSetShopSelection(group, data, selectorGroups)),
  clearShopSelection: (group, data) => dispatch(doClearShopSelection(group, data)),
  doClosePopup: (type) => dispatch(doHidePopup(type)),
  doShowPopup: (type) => dispatch(doShowPopup(type)),
  clearSearchTerm: (payload) => dispatch(clearSearchTerm(payload)),
  doSetShopSelectionMode: (mode, page) => dispatch(doSetShopSelectionMode(mode, page)),
  doClearShopLocalSelection: (payload) => dispatch(doClearShopLocalSelection(payload)),
  doGetShopList: (type) => dispatch(doGetShopList(type)),
  doSetLocalSelectedTab: (payload) => dispatch(doSetLocalSelectedTab(payload))
})

const mapStateToProps = state => ({
  selectorGroups: nullSafe(() => state.userProfiling.selectorGroups, []),
  shopSelections: nullSafe(() => state.shopPicker.group, []),
  shopSelectionFromPage: nullSafe(() => state.shopPicker.shopSelectionFromPage, 'default'),
  shopLocalSelection: nullSafe(() => state.shopPicker.shopLocalSelection, {}),
  searchTerm: nullSafe(() => state.shopPicker.searchTerm, ''),
  localSelectedTab: nullSafe(() => state.shopPicker.localSelectedTab, null)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ShopPickerPopup)
